const productsTypes = {
    FETCH_PRODUCTS_START: "FETCH_PRODUCTS_START",
    SET_PRODUCTS: "SET_PRODUCTS",
    FETCH_PRODUCT_URL_START: "FETCH_PRODUCT_URL_START",
    SET_PRODUCT_URL: "SET_PRODUCT_URL"
};

export default productsTypes;
